import React, { createContext, useState } from 'react';
export const RetainmentContext = createContext([]);

export const RetainmentProvider = props => {
    const [dashboardDetails, setDashboardDetails] = useState({
        company: '',
        persistedFilters: [],
    });
    return <RetainmentContext.Provider value={{ dashboardRetainment: [dashboardDetails, setDashboardDetails] }}>{props?.children}</RetainmentContext.Provider>;
};
